import { SVCurrencyInput } from '@/components/core';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { Grid, Stack, Typography } from '@mui/material';

export const FeeControls = () => {
  const {
    INCOMING_DOMESTIC_WIRE,
    OUTGOING_DOMESTIC_WIRE,
    MONTHLY_SAVINGS_ACCOUNT_FEE,
  } = PROGRAM_SETTINGS.FEE_CONTROLS;
  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} mb={2}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="feeIncomingDomestic"
            label={INCOMING_DOMESTIC_WIRE.LABEL}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} mb={2}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="feeOutcomeDomestic"
            label={OUTGOING_DOMESTIC_WIRE.LABEL}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} mb={2}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="feeMonthlySavingAccount"
            label={MONTHLY_SAVINGS_ACCOUNT_FEE.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            The fee will be the same for an individual, joint, and business
            account.
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};
